import { create } from 'zustand';

import { ResetPassword } from '@/libs/api';
import apiClient from '@/libs/api/client';
import { ForgotPasswordFillingSteps } from '@/util/constants';

import { runTask } from './modal';

type ForgotPasswordState = {
  userEmail: string;
  isTermsModalOpen: boolean;
  currentStep: number;
  isRequireTermsReadModalOpen: boolean;
  isDoNotAgreeTermsModalOpen: boolean;
  isAgreedToTerms: boolean;
  setUserEmail: (userEmail: string) => void;
  setIsTermsModalOpen: (isTermsModalOpen: boolean) => void;
  setCurrentStep: (currentStep: number) => void;
  setIsRequireTermsReadModalOpen: (value: boolean) => void;
  setIsDoNotAgreeTermsModalOpen: (value: boolean) => void;
  setIsAgreedToTerms: (value: boolean) => void;
  forgetPassword: () => Promise<boolean>;
  createNewPassword: (details: ResetPassword) => Promise<boolean>;
};

export const useForgotPasswordStore = create<ForgotPasswordState>((set, get) => ({
  userEmail: '',
  isTermsModalOpen: false,
  currentStep: ForgotPasswordFillingSteps.PASSWORD_RECOVERY_FILLING,
  isRequireTermsReadModalOpen: false,
  isDoNotAgreeTermsModalOpen: false,
  isAgreedToTerms: false,

  setUserEmail: (userEmail) => {
    set({ userEmail });
  },
  setIsTermsModalOpen: (isTermsModalOpen) => {
    set({ isTermsModalOpen });
  },
  setCurrentStep: (currentStep) => {
    set({ currentStep });
  },
  setIsRequireTermsReadModalOpen: (value: boolean) => {
    set({ isRequireTermsReadModalOpen: value });
  },
  setIsDoNotAgreeTermsModalOpen: (value: boolean) => {
    set({ isDoNotAgreeTermsModalOpen: value });
  },
  setIsAgreedToTerms: (value: boolean) => {
    set({ isAgreedToTerms: value });
  },
  forgetPassword: async () => {
    let isSuccess = false;

    await runTask(async () => {
      await apiClient.company.companyForgetPasswordCreate({ email: get().userEmail });
      isSuccess = true;
    });
    return isSuccess;
  },
  createNewPassword: async (details) => {
    const { uid, token, new_password1, new_password2 } = details;
    let isSuccess = false;
    await runTask(async () => {
      await apiClient.company.companyResetPasswordCreate({
        uid,
        token,
        new_password1,
        new_password2
      });
      isSuccess = true;
    });
    if (isSuccess) set({ currentStep: 3 });
    return isSuccess;
  }
}));
